<template>
  <div class="analysis">
    <div class="section">
      <div class="section-header">
        <h2 class="section-title">数据总览</h2>
        <el-button 
          type="text" 
          class="collapse-btn"
          @click="toggleSection('overview')"
        >
          <i :class="['el-icon-arrow-down', {'is-active': !collapsedSections.overview}]"></i>
        </el-button>
      </div>
      <div class="chart-row" v-show="!collapsedSections.overview">
        <study-effectiveness />
      </div>
    </div>

    <div class="section">
      <div class="section-header">
        <h2 class="section-title">比赛分析</h2>
        <el-button 
          type="text" 
          class="collapse-btn"
          @click="toggleSection('game')"
        >
          <i :class="['el-icon-arrow-down', {'is-active': !collapsedSections.game}]"></i>
        </el-button>
      </div>
      <div v-show="!collapsedSections.game">
        <div class="chart-row">
          <game-trend-chart class="full-width" />
        </div>
        <div class="chart-row">
          <game-count-trend class="full-width" />
        </div>
        <div class="chart-row">
          <game-distribution-chart class="half-width" />
          <game-scatter-chart class="half-width" />
        </div>
      </div>
    </div>

    <div class="section">
      <div class="section-header">
        <h2 class="section-title">题目分析</h2>
        <el-button 
          type="text" 
          class="collapse-btn"
          @click="toggleSection('question')"
        >
          <i :class="['el-icon-arrow-down', {'is-active': !collapsedSections.question}]"></i>
        </el-button>
      </div>
      <div v-show="!collapsedSections.question">
        <question-analysis ref="questionAnalysis" :show-tag-charts="false" />
      </div>
    </div>

    <div class="section">
      <div class="section-header">
        <h2 class="section-title">标签分析</h2>
        <el-button 
          type="text" 
          class="collapse-btn"
          @click="toggleSection('tag')"
        >
          <i :class="['el-icon-arrow-down', {'is-active': !collapsedSections.tag}]"></i>
        </el-button>
      </div>
      <div v-show="!collapsedSections.tag">
        <div class="chart-row">
          <tag-heatmap ref="tagHeatmap" class="full-width" />
        </div>
        <question-analysis ref="tagAnalysis" :only-tag-charts="true" />
      </div>
    </div>
  </div>
</template>

<script>
import GameTrendChart from './components/GameTrendChart.vue'
import GameDistributionChart from './components/GameDistributionChart.vue'
import GameScatterChart from './components/GameScatterChart.vue'
import StudyEffectiveness from './components/StudyEffectiveness.vue'
import QuestionAnalysis from './components/QuestionAnalysis.vue'
import GameCountTrend from './components/GameCountTrend.vue'
import TagHeatmap from './components/TagHeatmap.vue'

export default {
  name: 'Analysis',
  components: {
    GameTrendChart,
    GameDistributionChart,
    GameScatterChart,
    StudyEffectiveness,
    QuestionAnalysis,
    GameCountTrend,
    TagHeatmap
  },
  data() {
    return {
      collapsedSections: {
        overview: false,
        game: false,
        question: false,
        tag: false
      }
    }
  },
  methods: {
    toggleSection(section) {
      const next = !this.collapsedSections[section]
      this.collapsedSections[section] = next
      this.$nextTick(() => {
        if (!this.collapsedSections.question && this.$refs.questionAnalysis) {
          this.$refs.questionAnalysis.forceResizeAll && this.$refs.questionAnalysis.forceResizeAll()
        }
        if (!this.collapsedSections.tag) {
          if (this.$refs.tagHeatmap) {
            this.$refs.tagHeatmap.forceResize && this.$refs.tagHeatmap.forceResize()
          }
          if (this.$refs.tagAnalysis) {
            this.$refs.tagAnalysis.forceResizeAll && this.$refs.tagAnalysis.forceResizeAll()
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.analysis {
  padding: 8px 0;
}

.section {
  margin-bottom: 20px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #2E365A;
  position: relative;
  padding-left: 12px;
  display: flex;
  align-items: center;
  margin: 0;
}

.section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  background: #409EFF;
  border-radius: 2px;
}

.collapse-btn {
  padding: 0;
  height: auto;
}

.collapse-btn i {
  font-size: 20px;
  color: #909399;
  transition: transform 0.3s;
}

.collapse-btn i.is-active {
  transform: rotate(180deg);
}

.chart-row {
  display: flex;
  width: 100%;
  margin-bottom: 16px;
  gap: 24px;
}

.chart-row:last-child {
  margin-bottom: 0;
}

.full-width {
  width: 100%;
}

.half-width {
  width: 50%;
  flex: 0 0 50%;
}

.analysis-container {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -8px;
}
</style> 